<template>
  <div class='pc_banner'>
    <!-- 搜索 -->
    <div class='pc_select'>
      <el-row>
        <el-col :span='12'
          ><div class='grid-content bg-purple'>
            <el-form
              :inline='true'
              :model='selectForm'
              class='demo-form-inline'
              :rules="selectRole"
              ref="selectform"
              :validate-on-rule-change='false'
              @submit.native.prevent
            >
              <el-form-item label='' prop="phone">
               <el-input @keyup.enter.native='onSelect("selectform")' v-model='selectForm.phone' clearable @clear="handleClear" placeholder="输入手机号码"></el-input>
              </el-form-item>
              <el-form-item label=''>
               <el-input @keyup.enter.native='onSelect("selectform")' v-model='selectForm.username' clearable @clear="handleClear" placeholder="输入用户名"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type='primary' @click='onSelect("selectform")'>搜索</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
        <el-col :span='10'
          ><div class='grid-content bg-purple'>&nbsp;</div></el-col
        >
        <el-col :span='2'></el-col>
      </el-row>
    </div>
    <!-- 表格区域 -->
    <el-table
      :data='tableData'
      border
      v-loading='loading'
      style='width: 100%'
    >
      <el-table-column fixed prop='id' label='ID' width='100'></el-table-column>
      <el-table-column
        prop='username'
        label='用户名'
        width='140'
      ></el-table-column>
      <el-table-column
        prop='phone'
        label='手机号码'
        width='180'
      ></el-table-column>
      <el-table-column prop='role' label='角色' width='100'>
        <template slot-scope='scope'>
          <el-tag type='warning' v-if='scope.row.role == 0'>游客</el-tag>
          <el-tag v-if='scope.row.role == 1'>教师</el-tag>
          <el-tag type='success' v-if='scope.row.role == 2'>学生</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop='create_time' label='创建时间'> </el-table-column>
      <el-table-column prop='update_time' label='更新时间'> </el-table-column>
      <el-table-column fixed='right' label='操作' width='220'>
        <template slot-scope='scope'>
          <el-tooltip class='item' effect='dark' content='编辑' placement='top'>
            <el-button
              type='success'
              icon='el-icon-edit'
              size="small"
              @click='handleClick(scope.row.id)'
            ></el-button>
          </el-tooltip>
          <el-tooltip class='item' effect='dark' content='删除' placement='top'>
            <el-button
              :disabled='true'
              type='danger'
              size="small"
              icon='el-icon-delete'
              @click='handleDeleteClick(scope.row.id)'
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class='pc_pages'>
      <div class='block'>
        <!-- <span class='demonstration'>完整功能</span> -->
        <el-pagination
          @size-change='handleSizeChange'
          @current-change='handleCurrentChange'
          :current-page='currentPage'
          :page-sizes='sizes'
          :page-size='sizePage'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :title='title'
      :visible.sync='EditorDialogVisible'
      width='45%'
      :lock-scroll='false'
      @closed='closed'
      v-if='EditorDialogVisible'
    >
        <el-form
          :label-position='"lift"'
          label-width='110px'
          :model='editorForm'
        >
          <el-form-item label='ID' >
            <el-input v-model='editorForm.id' :disabled='true'></el-input>
          </el-form-item>
          <el-form-item label='用户名' >
            <el-input v-model='editorForm.username' :disabled='true'></el-input>
          </el-form-item>
          <el-form-item label='手机号' >
            <el-input v-model='editorForm.phone' :disabled='true'></el-input>
          </el-form-item>
          <el-form-item label='角色' >
            <el-radio-group v-model='editorForm.role'>
              <el-radio label='0'>游客</el-radio>
              <el-radio label='1'>教师</el-radio>
              <el-radio label='2'>学生</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label='权限' >
            <el-select
              v-model='editorForm.access'
              multiple
              placeholder='请选择'
            >
              <el-option
                v-for='item in accessList'
                :key='item.id'
                :label='item.title'
                :value='item.id'
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='上次更新时间' >
            <el-input
              v-model='editorForm.update_time'
              :disabled='true'
            ></el-input>
          </el-form-item>
        </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='EditorDialogVisible = false'>取 消</el-button>
        <el-button type='primary' @click='editorSubmit'>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { initStudentList,initCoursThreeList,findStudents,saveStudents,deleteStudents }  from 'api/post/postApi.js';
import { isPhone } from 'untils/form_validation.js';
export default {
  name: 'pc_cat_two',
  components: {},
  data() {
    return {
      loading: true,
      tableData: [],
      accessList: [],
      // 分页功能参数
      total: 0,
      sizes: [10, 20, 30, 40],
      sizePage: 10,
      currentPage: 1,
      selectForm: {
        phone: '',
      },
      selectRole:null,
      EditorDialogVisible: false,
      editorForm: {},
      title: ''
    };
  },
  created() {
    // 数据初始化
    this.initData();
  },
  mounted() {
    this.selectRole=isPhone;
    this.getAccesslist();
  },
  // 计算属性
  computed: {
    // 分页控制
    // getTabeData: function () {
    //   const tableData = this.tableData.slice(
    //     (this.currentPage - 1) * this.sizePage,
    //     this.currentPage * this.sizePage
    //   );
    //   return tableData;
    // }
  },
  methods: {
    // 初始化数据
    async initData() {
      const { data: res } = await initStudentList(this.selectForm);
      this.tableData = res.data.data;
      this.total = res.data.total;
      this.loading = false;
    },
    // 获取所有三级科目信息
    async getAccesslist() {
      const { data: res } = await initCoursThreeList();
      let oldarr = res.data;
      let obj = { id: '', title: '' };
      var arrs = [];
      oldarr.forEach((element) => {
        // 处理得到的数据
        obj.id = element.id;
        obj.title = element.title;
        arrs.push(obj); // 赋值
        obj = { id: '', title: '' }; // 清空  循环添加
      });
      this.accessList = arrs;
    },
    // 分页功能实现
    // 每页显示
    handleSizeChange(val) {
      this.sizePage = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.selectForm.page = val;
      this.initData();
    },
    // 编辑打开
    async handleClick(sid) {
      this.title = '编辑学生信息';
      const params= { id:sid };
      const { data: res } = await findStudents(params);
      this.editorForm = res.data;
      // 修改数据类型，以作数据回显
      if (this.editorForm.access === '') {
        this.editorForm.access = [];
      } else {
        let access = this.editorForm.access.split(','); // 转为数组
        let newaccess = access.map(Number); // 将数组元素转换为数值型
        this.editorForm.access = newaccess;
      }

      this.editorForm.role = this.editorForm.role.toString();
      this.EditorDialogVisible = true;
    },
    // 编辑提交
    async editorSubmit() {
      // 修改提交数据的类型
      const oldarr = this.editorForm.access;
      const newarr = oldarr.map(String);
      const straccess = newarr.toString();
      this.editorForm.access = straccess;
      const { data: res } = await saveStudents(this.editorForm);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error('更新失败！');
      } else {
        this.$message.success('更新成功！');
        this.initData();
      }
      this.EditorDialogVisible = false;

    },
    // 公用的dialog清空逻辑
    closed() {
      this.editorForm = {};
    },
    // 删除
    async handleDeleteClick(sid) {
      // 询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该信息, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除！');
      }
      const params = { id:sid };
      const { data: res } = await deleteStudents(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error('删除失败！');
      } else {
        this.$message.success('删除成功！');
        this.initData();
      }

    },
    // 搜索实现
    onSelect(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.selectForm.page = '';
          const { data:res } = await initStudentList(this.selectForm);
          if (res.status !== 0) {
            this.$message.error('查找失败！');
            return;
          }
          this.$message.success('查找成功！');
          // console.log(res.data)
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.$message.error('表单验证未通过！');
          return false;
        }
      });
    },
    // 搜索清除
    handleClear(){
      this.selectForm={};
      this.initData();
    }
  }
};
</script>

<style scoped>
.pc_pages {
  height: 100px;
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
.pc_select {
  width: 100%;
}
.cratebtn {
  float: right;
}
</style>